import React, { useState } from "react";
import { usePermission } from "imports/Utils";
import ContractDetailsBlock from "./ContractDetailsBlock";
import ContractCreateBlock from "./ContractCreateBlock";
import ContractAgreementsBlock from "./ContractAgreementsBlock";
import DeclarationBlock from "view/charters/dossier/contract/DeclarationBlock";
import { Height, LoadingBlock } from "../Blocks";
import { Contract, PurchaseCharter, SalesCharter } from "types/index";
import { PurchaseCharterFromQuery } from "view/charters/PurchaseCharterDetails";
import { CharterContractFragment } from "__generated__/view/contractsNew/graphql/contract.fragments.generated";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";

type UseCargoBlockProps = {
	charter?: SalesCharter | PurchaseCharter | PurchaseCharterFromQuery;
	contract?: Contract | CharterContractFragment;
	loading: boolean;
	refetch: () => void;
	isOtherCharter: boolean;
	otherContractId?: number;
	voyageId?: number;
	simpleInvoicing?: boolean;
};

const useContractBlock = ({ charter, contract, loading, refetch, isOtherCharter, otherContractId, voyageId, simpleInvoicing }: UseCargoBlockProps) => {

	const { isReadOnly } = usePermission();

	const [ createOrLinkContract, setCreateOrLinkContract ] = useState(false);

	return {
		contractBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Small} />
				);
			} else if (charter?.allContracts && contract && !createOrLinkContract) {
				return (
					<ContractDetailsBlock
						charter={charter}
						contracts={charter.allContracts}
						color={getCharterTypeColor(charter.type, charter.subtype)}
						refetch={refetch}
						onCreateOrLinkContract={() => setCreateOrLinkContract(true)}
						isOtherCharter={isOtherCharter}  />
				);
			} else if (charter && (!contract || createOrLinkContract) && !isReadOnly) {
				return (
					<ContractCreateBlock
						charter={charter}
						contract={contract}
						color={getCharterTypeColor(charter.type, charter.subtype)}
						goBack={() => setCreateOrLinkContract(false)}
						refetch={() => {
							refetch();
							setCreateOrLinkContract(false);
						}} />
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),

		invoicingBlock: function() {
			if (loading) {
				return <LoadingBlock
					height={Height.Large} />;
			} else if (charter && contract) {
				return <DeclarationBlock
					charter={charter}
					contract={contract}
					color={getCharterTypeColor(charter.type, charter.subtype)}
					simple={simpleInvoicing}
				/>;
			} else {
				return <React.Fragment />;
			}
		}(),

		agreementsBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Large} />
				);
			} else if (charter && contract) {
				return (
					<ContractAgreementsBlock
						charter={charter}
						contract={contract}
						color={getCharterTypeColor(charter.type, charter.subtype)}
						refetch={refetch}
						otherContractId={otherContractId}
						voyageId={voyageId}
					/>
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),
	};
};

export default useContractBlock;
